module.exports = __webpack_public_path__ + "img/decef4fe2188de6a91488a9d9a6d99ea.png";